import React from "react";
import { Form as AntForm } from "antd";
import { FormInstance } from "antd/lib/form/hooks/useForm";
import FormContext from "../../../context/FormContext";
import { FieldConfig } from "./Interfaces";

interface Props {
  config: { [key: string]: FieldConfig };
  errors: { [key: string]: string[] | null };
  onFinishHandler?: (values: object) => void;
  children: React.ReactNode;
  form: FormInstance<object>;
  initialValues?: { [name: string]: any };
  className?: string;
}

const Form: React.FC<Props> = ({
  config,
  onFinishHandler,
  children,
  form,
  errors,
  initialValues,
  className,
}) => (
  <FormContext.Provider value={{ config, errors }}>
    <AntForm
      className={className}
      onFinish={onFinishHandler}
      form={form}
      initialValues={initialValues}
    >
      {children}
    </AntForm>
  </FormContext.Provider>
);

export default Form;
